// components
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
} from '@/components/PageSection';
import { GroupLabel } from '@/components/GroupLabel';

// styles
import { ListsWrapper } from './WhoUses.styles';

export function WhoUses({ content }) {
  return (
    <PageSection>
      <PageSectionInner>
        <PageSectionTitle>{content.title}</PageSectionTitle>
        <ListsWrapper>
          {content.groups.map((group) => (
            <div key={`who-uses-${group.label}`}>
              <GroupLabel as="h3">{group.label}</GroupLabel>
              <ul>
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </ListsWrapper>
      </PageSectionInner>
    </PageSection>
  );
}
